import React, { useEffect } from 'react';

const MetaTags = ({
  title = "beatt pulse - Plataformas de Quick Checks Pulse",
  description = "beatt pulse - Plataformas de Quick Checks Pulse",
  url = "https://beattpulse.com/",
  image = "https://beattpulse.com/og-image.jpg"
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update meta tags
    const updateMetaTag = (property, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${property}"]`);

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Standard meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', 'quick checks, pulse, beatt pulse, plataforma, checks');

    // Open Graph meta tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:url', url, true);
    updateMetaTag('og:image', image, true);
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:site_name', 'beatt pulse', true);

    // Twitter meta tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);
    updateMetaTag('twitter:url', url);

    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    // Update structured data
    let structuredData = document.querySelector('script[type="application/ld+json"]');
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "beatt pulse",
      "description": description,
      "url": "https://beattpulse.com",
      "logo": "https://beattpulse.com/logo.png",
      "sameAs": [
        "https://www.linkedin.com/company/beattpulse",
        "https://x.com/beattpulse"
      ]
    };

    if (!structuredData) {
      structuredData = document.createElement('script');
      structuredData.setAttribute('type', 'application/ld+json');
      document.head.appendChild(structuredData);
    }
    structuredData.textContent = JSON.stringify(schemaData);

  }, [title, description, url, image]);

  return null; // This component doesn't render anything
};

export default MetaTags;